import { api, apiUrl } from "./../../api/index";

const url = `${apiUrl}/leaders`;

export const fetchLeaders = () => {
  return api(url, {
    method: "GET",
  }).then(res => res.json());
};
